<template>
  <div class="filter-content">
    <div class="filter-header">
      <i class="el-icon-s-operation"></i>
      <span>Data Filter</span>
    </div>
    <div class="filter-body">
      <el-select v-model="selectedVariable" placeholder="Variable" clearable filterable size="small" class="sel-var">
        <el-option
          v-for="obs in variableOptions"
          :key="obs.name"
          :label="obs.name"
          :value="obs.name"
        />
      </el-select>
      <el-select v-model="selectedValues" multiple placeholder="Categories" size="small" clearable class="sel-values" :disabled="!selectedVariable">
        <el-option
          v-for="val in currentValues"
          :key="String(val)"
          :label="formatValue(val)"
          :value="val"
        />
      </el-select>
    </div>
    <div class="filter-status" v-if="hasActiveFilter">
      <el-tag type="success" size="small" closable @close="clearFilter">
        <i class="el-icon-check"></i> {{ selectedVariable }} ({{ selectedValues.length }})
      </el-tag>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterButton',
  props: {
    project: { type: Object, required: false }
  },
  emits: ['change'],
  data() {
    return {
      selectedVariable: '',
      selectedValues: []
    }
  },
  watch: {
    selectedVariable() {
      this.selectedValues = []
      this.emitChange()
    },
    selectedValues() {
      this.emitChange()
    }
  },
  computed: {
    variableOptions() {
      const list = this.project && Array.isArray(this.project.obs_variables) ? this.project.obs_variables : []
      return list
    },
    currentValues() {
      const v = (this.variableOptions || []).find(x => x && x.name === this.selectedVariable)
      const values = v && Array.isArray(v.unique_values) ? v.unique_values : []
      return values
    },
    hasActiveFilter() {
      return !!this.selectedVariable && this.selectedValues.length > 0
    }
  },
  methods: {
    formatValue(v) {
      if (v === null || v === undefined || v === '') return 'NA'
      return String(v)
    },
    emitChange() {
      const hasVar = !!this.selectedVariable
      const hasVals = Array.isArray(this.selectedValues) && this.selectedValues.length > 0
      const filter = (hasVar && hasVals)
        ? { include: { [this.selectedVariable]: this.selectedValues.slice() } }
        : {}
      this.$emit('change', filter)
    },
    clearFilter() {
      this.selectedVariable = ''
      this.selectedValues = []
    }
  }
}
</script>

<style scoped>
.filter-content {
  width: 100%;
}

.filter-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 10px;
}

.filter-header i {
  color: #3b82f6;
}

.filter-body {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.sel-var {
  min-width: 120px;
  flex: 1;
}

.sel-values {
  min-width: 160px;
  flex: 1.5;
}

.filter-status {
  margin-top: 10px;
}
</style>

